<template src="./template.html" />

<script>
import { Content, Stage } from '@neurotrack/web-shared-components'
import VideoWithButton from '@/components/VideoWithButton/VideoWithButton.vue'

export default {
  name: 'EOPCheck',
  components: { Content, VideoWithButton, Stage },
  props: {
    examRoute: {
      type: String,
      required: true
    }
  },
  methods: {
    confirmedHandler() {
      this.$router.push({ path: `/exam/${this.examRoute}` })
    }
  }
}
</script>
